import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-suguyaku-forgot-password',
  templateUrl: './suguyaku-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './suguyaku-forgot-password.component.css',
  ],
})
export class SuguyakuForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> { }
}
